export const SIDE_PANEL_COLLAPSED_HEIGHT_PX = 106;
export const SIDE_PANEL_COLLAPSED_BUFFER_PX = 28;
export const OPEN_TOP_GAP_PX = 40;
